// extracted by mini-css-extract-plugin
export default {"layout-content-container":"AlbumContent_layout-content-container__Qlx2m","content-container":"AlbumContent_content-container__MV0FL"};